var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"d-none d-md-flex exit-impersonation",on:{"click":_vm.exitImpersonation}},[_c('fa',{staticClass:"icon",attrs:{"icon":"user-secret"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }